var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("page-title", {
        attrs: { icon: "#icon-appmanage", title: _vm.pageTitle }
      }),
      _vm._v(" "),
      _vm.isLimited
        ? _c("div", { staticClass: "limited-wrap warning-tip" }, [
            _c("p", [_vm._v("尊敬的客户，")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "为保障账号安全和风险控制，我们对用户创建应用的数量进行了限制；"
              )
            ]),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("未认证用户只允许创建"),
                _c("span", [_vm._v("1个")]),
                _vm._v("应用；"),
                _c(
                  "router-link",
                  { attrs: { to: "/user/authentication/personal" } },
                  [_vm._v("个人实名认证")]
                ),
                _vm._v("用户可创建"),
                _c("span", [_vm._v("5个")]),
                _vm._v("应用，"),
                _c(
                  "router-link",
                  { attrs: { to: "/user/authentication/company" } },
                  [_vm._v("企业实名认证")]
                ),
                _vm._v("用户可创建"),
                _c("span", [_vm._v("20")]),
                _vm._v("个应用；")
              ],
              1
            ),
            _vm._v(" "),
            _c("p", [
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href:
                      _vm.baseUrl + "/doc/authentication/authentication.html"
                  }
                },
                [_vm._v("了解开放平台用户认证须知 >>")]
              )
            ])
          ])
        : _c(
            "div",
            { staticClass: "create-wrap" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    "label-position": "top",
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "1.25rem"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "应用名称", prop: "appName" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "large",
                          placeholder: "请设定一个应用名称，少于30个字符",
                          "auto-complete": "off"
                        },
                        model: {
                          value: _vm.form.appName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "appName", $$v)
                          },
                          expression: "form.appName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "应用分类", prop: "appCategory" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "large",
                          icon: "caret-bottom",
                          placeholder: "应用分类标签最多选一个",
                          readonly: ""
                        },
                        nativeOn: {
                          click: function($event) {
                            _vm.isShowCategoryList = !_vm.isShowCategoryList
                          }
                        },
                        model: {
                          value: _vm.form.appCategory,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "appCategory", $$v)
                          },
                          expression: "form.appCategory"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm.isShowCategoryList
                            ? _c("category-select", {
                                attrs: { categoryList: _vm.categoryList },
                                on: {
                                  categoryChange: _vm.setCategary,
                                  hideCategoryList: _vm.hideCategoryList
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "应用功能描述", prop: "appDescr" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "large",
                          type: "textarea",
                          autosize: { minRows: 4, maxRows: 8 },
                          placeholder:
                            "请简述使用场景、应用特点等信息，不超过1000个字符",
                          "auto-complete": "off"
                        },
                        model: {
                          value: _vm.form.appDescr,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "appDescr", $$v)
                          },
                          expression: "form.appDescr"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-submit",
                          attrs: { size: "large", type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.submitForm("form")
                            }
                          }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass: "link-create",
                          attrs: { to: "/app/myapp" }
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { type: "text", size: "large" } },
                            [
                              _vm._v(
                                "\n              返回我的应用\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fddfc574", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fddfc574","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/Dashboard/App/Create/Main.vue
// module id = 2153
// module chunks = 19